import { TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";

export default function Input(props) {
  const {
    name,
    label,
    value,
    variant,
    size,
    onChange,
    error = null,
    required = false,
    fullWidth = true,
    autoFocus,
    ...other
  } = props;
  const inputRef = useRef();

  const handleFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 10);
  };

  useEffect(() => {
    autoFocus && handleFocus();
    return () => {};
  }, [autoFocus]);

  return (
    <TextField
      variant={variant || "outlined"}
      size={size || "small"}
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      required={required}
      inputRef={inputRef}
      {...other}
      {...(error && { error: true, helperText: error })}
    />
  );
}
